module.exports = __webpack_public_path__ + "static/media/feature_2.34695eb2.jpg";